import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DataState {
  allContent: any[];
  preview: any[];
  dynamicContent: any[];
  response: string;
}

const initialState: DataState = {
  allContent: [],
  dynamicContent: [],
  preview: [],
  response: "",
};

export const dataSlice = createSlice({
  name: "data",
  initialState,

  reducers: {
    setAllContent: (state, action: PayloadAction<any>) => {
      state.allContent = action.payload;
    },

    setDynamicContent: (state, action: PayloadAction<any>) => {
      state.dynamicContent = action.payload;
    },

    createPreview: (state, action: PayloadAction<any>) => {
      state.preview = action.payload;
    },

    setResponse: (state, action: PayloadAction<string>) => {
      state.response = action.payload;
    },
  },
});

export const { setAllContent, createPreview, setDynamicContent, setResponse } =
  dataSlice.actions;

export default dataSlice.reducer;
